/***
 * 新老客分析
 */
import { post, get, postJson, put, postBlob } from '../axios'

//导出数据
export const exportDataOne = p => postJson(`/customer-analysis/newAndOldAnalysis/export`, p);

// 列表数据
export const getTableData = p => get(`/customer-analysis/newAndOldAnalysis/list`, p);